// Fatia `termos da plataforma` do slice `aiFramework/creditos` (spec-009 [US-1], T004).
//
// ★ POR QUE AQUI, E NÃO NUM MÓDULO PRÓPRIO. O aceite só existe por causa da contratação:
// quem o lê é a mesma tela que lê planos e assinatura, e quem o grava é o mesmo clique que
// cria a assinatura. Um módulo namespaced separado obrigaria o fluxo de dinheiro a
// despachar com `{ root: true }` para o irmão a cada passo. O que se separa é o ARQUIVO —
// terceiro do slice, ao lado de `creditos-assinatura.js`, pelo mesmo motivo dele.
//
// ★ QUEM BUSCA É A API. Toda action daqui é setter puro; quem faz o GET/POST, versiona a
// leitura e guarda o duplo clique é `apiAiFrameworkTermos`.
//
// ★ O que o servidor manda, e o que ele NUNCA recebe: `versao_vigente`, `url_termos`,
// `aceito` e `aceito_em` vêm do GET; o POST vai SEM CORPO — identidade sai da sessão,
// versão do termo sai do servidor, IP e user-agent saem do request. Nada que o cliente
// mande é confiado, e por isso nada é mandado.

// ── State ─────────────────────────────────────────────────────────────────────────────
function stateTermos() {
  return {
    // Envelope do GET ({ versao_vigente, url_termos, aceito, aceito_em }) ou null (não
    // carregado). `aceito: false` é estado VÁLIDO — "ainda não aceitou" — e é o que faz a
    // caixa aparecer; `null` é "não sei", e aí a tela pede o aceite do mesmo jeito (a
    // falha de leitura nunca libera a assinatura por omissão).
    termos: null,
    termosLoading: false,
    // Mensagem da leitura que falhou, ou null. Não vira bloco de erro na tela: a caixa
    // continua lá, e o aceite é pedido de novo — o pior caso é pedir duas vezes, nunca
    // deixar passar sem pedir.
    termosErro: null,

    // ── A ESCRITA (AC-1.3/AC-1.4) ──
    // Guard BLOQUEANTE do registro do aceite: o segundo pedido não sai. O servidor é
    // idempotente, mas o clique duplo aqui atrasaria a saída para a Stripe por uma
    // segunda ida à rede que não muda nada.
    termosAceiteLoading: false,
    // Mensagem do servidor quando a gravação falha — é ela que a tela mostra, e é ela
    // que segura o consultor DENTRO da plataforma (AC-1.4).
    termosAceiteErro: null,
  }
}

// ── Getters ───────────────────────────────────────────────────────────────────────────
const gettersTermos = {
  termos: (s) => s.termos,
  termosLoading: (s) => s.termosLoading,
  termosErro: (s) => s.termosErro,
  termosAceiteLoading: (s) => s.termosAceiteLoading,
  termosAceiteErro: (s) => s.termosAceiteErro,
}

// ── Mutations ─────────────────────────────────────────────────────────────────────────
const mutationsTermos = {
  SET_TERMOS(s, payload) {
    s.termos = payload || null
  },
  SET_TERMOS_LOADING(s, payload) {
    s.termosLoading = payload
  },
  SET_TERMOS_ERRO(s, payload) {
    s.termosErro = payload || null
  },
  SET_TERMOS_ACEITE_LOADING(s, payload) {
    s.termosAceiteLoading = payload
  },
  SET_TERMOS_ACEITE_ERRO(s, payload) {
    s.termosAceiteErro = payload || null
  },
}

// ── Actions ───────────────────────────────────────────────────────────────────────────
// Setters: só commitam. Quem os chama é a `apiAiFrameworkTermos`.
const actionsTermos = {
  setTermos({ commit }, payload) {
    commit('SET_TERMOS', payload)
  },
  setTermosLoading({ commit }, payload) {
    commit('SET_TERMOS_LOADING', payload)
  },
  setTermosErro({ commit }, payload) {
    commit('SET_TERMOS_ERRO', payload)
  },
  setTermosAceiteLoading({ commit }, payload) {
    commit('SET_TERMOS_ACEITE_LOADING', payload)
  },
  setTermosAceiteErro({ commit }, payload) {
    commit('SET_TERMOS_ACEITE_ERRO', payload)
  },
}

export { stateTermos, gettersTermos, mutationsTermos, actionsTermos }
